import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { ChapterItemComponent } from '@app/+onboarding/chapters/components/chapter-item.component';
import { ChapterStepComponent } from '@app/+onboarding/chapters/components/chapter-step/chapter-step.component';
import { UserGuideType } from '@app/reducers/orm/user-guide/user-guide.model';
import { TrackingService } from '@app/services/tracking.service';
import { SmbHospitalityOnboardingChecklistStep } from '@app/shared/onboarding/onboarding-checklist.model';
import { OnboardingChecklistService } from '@app/shared/onboarding/onboarding-checklist.service';
import { TranslateModule } from '@ngx-translate/core';
import { DIALOG_DATA, DialogActivationComponent, DialogActivationFlowOrder, DialogRef } from '@sb/ui';
import { take } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-app-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogActivationComponent, ChapterStepComponent, ChapterItemComponent],
  templateUrl: './mobile-app-dialog.component.html',
})
export class MobileAppDialogComponent {
  public DialogActivationFlowOrder = DialogActivationFlowOrder;
  public constructor(
    @Inject(DIALOG_DATA) public readonly eventData,
    private readonly dialogRef: DialogRef<unknown, OnboardingDialogResult>,
    private readonly onboardingChecklist: OnboardingChecklistService,
    private readonly trackingService: TrackingService,
  ) {}

  public get qrCodeImagePath(): string {
    switch (environment.env) {
      case 'production':
        return 'assets/images/onboarding/chapters/mobile-app/QRAppProduction.png';
      default:
        return 'assets/images/onboarding/chapters/mobile-app/QRAppTrunk.png';
    }
  }

  public close(action: OnboardingDialogResult): void {
    this.trackingService.event('Onboarding Download Mobile App Completed', this.eventData);

    void this.onboardingChecklist
      .completeStep(UserGuideType.SELF_ONBOARDING_CHECKLIST, SmbHospitalityOnboardingChecklistStep.MOBILE_APP)
      .pipe(take(1))
      .subscribe(() => {
        this.dialogRef.close(action);
      });
  }
}
